import Icon from '../components/Icon.vue'

Icon.register({
  'level-up-alt': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M313.6 119.7L209.6 7.7C200.1-2.5 183.9-2.6 174.4 7.7L70.4 119.7C56.2 135 67.1 160 88 160H152V432H68A12-12 0 0 1 59.5 435.5L3.5 491.5C-4 499.1 1.3 512 12 512H208C221.3 512 232 501.3 232 488V160H296C316.8 160 327.8 135 313.6 119.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/level-up-alt.js
// module id = cwmn
// module chunks = 144